module.exports = {
      id: "share-usage",
      viewBox: "0 0 10 10",
      url: "/" + "sprite.67d9a3e87988b596c0329bae93bfba4b.svg#share",
      toString: function () {
        return this.url;
      }
    }